import { render } from "./DeleteShortcutModal.vue?vue&type=template&id=34d440f9&scoped=true"
import script from "./DeleteShortcutModal.vue?vue&type=script&lang=js"
export * from "./DeleteShortcutModal.vue?vue&type=script&lang=js"

import "./DeleteShortcutModal.vue?vue&type=style&index=0&id=34d440f9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d440f9"]])

export default __exports__